module.exports = __webpack_public_path__ + "static/media/banner.cc7a998d.png";